// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class CustomSectionsService {
   $timeout: any
   config: any
   menuManager: any
   results: any
   scope: any
   constructor(results: any, $timeout: any, config: any, menuManager: any) {
      this.update = this.update.bind(this)
      this.showMore = this.showMore.bind(this)
      this.showLess = this.showLess.bind(this)
      this.results = results
      this.$timeout = $timeout
      this.menuManager = menuManager
      this.config = config.data.customSections
      this.scope = {
         sections: [],
         limit: this.config.defaultSectionsDisplayed,
         minLimit: this.config.defaultSectionsDisplayed,
         showMoreOptionally: this.config.showMoreEnabled,
         showMore: this.showMore,
         showLess: this.showLess
      }
      this.results.on('new', () => {
         return this.update()
      })
   }

   update() {
      this.scope.limit = this.scope.minLimit
      // delay rendering of custom sections to allow search results to display first
      return this.$timeout(() => { 
         this.scope.sections = this.results.data.search.recommendations.custom_sections || []
         // in effect, remove limit by setting it to be  the same as amount of sections unless 'showMoreEnabled'

         this.menuManager.menu.thirdPanel.updateContent('customSections', this.scope.sections.length > 0)
         if (!this.scope.showMoreOptionally) {
            return this.scope.limit = this.scope.sections.length
         }
      }) 
   }

   showMore() {
      return this.scope.limit = this.scope.sections.length
   }

   showLess() {
      return this.scope.limit = this.scope.minLimit
   }
}

CustomSectionsService.$inject = ['dataService', '$timeout', 'configService', 'menuManagerService']

angular.module('summonApp.services')
   .service('customSectionsService', CustomSectionsService)
